import { render } from "./Table.vue?vue&type=template&id=4f0b2758&scoped=true"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"

import "./Table.vue?vue&type=style&index=0&id=4f0b2758&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f0b2758"],['__file',"src/components/mdbvue/Tables/Table.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f0b2758"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f0b2758', __exports__)) {
    api.reload('4f0b2758', __exports__)
  }
  
  module.hot.accept("./Table.vue?vue&type=template&id=4f0b2758&scoped=true", () => {
    api.rerender('4f0b2758', render)
  })

}


export default __exports__